document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/products/heat') {
    var sliderHTML = `
      <div class="image-text-slider-wrapper">
      <h2 class="mt-1 mb-8 text-[32px] lg:text-[40px] font-medium leading-[120%] font-interRegular">How HEAT Works</h2>
        <div class="swiper image-text-slider" js-mobile-slider="container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="image-text-block">
                <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/unroll_final_v2.gif?v=1756586453"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Lay Down & Position</h3>
                <p>Unroll it, place your elbow or heel in the sleeve and THEN… press POWER button for 3 seconds (ON/OFF).</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="image-text-block">
              <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/turn_on_final.gif?v=1756586453"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Warm Up</h3>
                <p>Wear thin socks for optimal comfort. The longer you use the device, the hotter it will feel, gently warming the targeted area and helping relax tight muscles.</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="image-text-block">
              <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/stretch_final.gif?v=1756586452"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Stretch & Enhance Recovery</h3>
                <p>The CastleFlexx Heat Edition helps increase circulation, improves your overall stretching experience and increases flexibility faster.</p>
              </div>
            </div>
          </div>
          <div class="swiper-pagination" js-mobile-slider="pagination"></div>
        </div>
      </div>
    `;

    // insert before .image-hotspots
    var target = document.querySelector(".image-hotspots");
    if (target) {
      target.insertAdjacentHTML("beforebegin", sliderHTML);
    }

    if (window.innerWidth < 768){
    const container = document.querySelector('[js-mobile-slider="container"]');
    const pagination = document.querySelector('[js-mobile-slider="pagination"]');
    // Init Swiper using theme’s alias (O + ne)
      new O(container, {
        modules: [ne],
        slidesPerView: 1.6,
        spaceBetween: 15,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    }
  }
  // Enavi 3-1-R-HP-Featured Products ATC //
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('trigger_atc') === 'true') {
    document.body.classList.add("show-atc-popup");
  const escapeSelector = s => CSS?.escape ? CSS.escape(s) : s;
  // Show/hide variant popup
  const handlePopupToggle = (btn) => {
    const targetClass = btn.getAttribute("data-target");
    if (!targetClass) return;

    document.querySelectorAll(".plp-variant-inner").forEach(el => el.classList.remove("active-plp-variant"));

    const targetEl = document.querySelector(`.plp-variant-inner.${targetClass}`);
    if (targetEl) {
      targetEl.classList.add("active-plp-variant");
      document.body.classList.add("variant-popup-open");
    }
  };

  const closeAllPopups = () => {
    document.querySelectorAll(".plp-variant-inner").forEach(el => el.classList.remove("active-plp-variant"));
    document.body.classList.remove("variant-popup-open");
  };

  // Update the label <span> text
  const updateLabel = (swatch) => {
    const optionGroup = swatch.closest("fieldset");
    if (!optionGroup) return;

    const labelSpan = optionGroup.closest(".plp-options-wrapper")?.querySelector(".option-name span");
    if (labelSpan) labelSpan.textContent = swatch.getAttribute("data-swatch") || swatch.getAttribute("data-value") || swatch.getAttribute("data-color");
  };
  const getSelectedVariant = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    return Array.from(hiddenSelect.options).find(opt => {
      const optValues = [opt.getAttribute("data-option1"), opt.getAttribute("data-option2"), opt.getAttribute("data-option3")].filter(Boolean);
      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });
  };

  const updatePrice = (activePopup) => {
    const matchedVariant = getSelectedVariant(activePopup);
    const priceEl = activePopup.querySelector(".plp-variant-price");
    if (priceEl) {
      priceEl.textContent = matchedVariant?.getAttribute("data-price") || '';
    }
    if(matchedVariant?.getAttribute("data-price") == undefined){
      activePopup.querySelector(".add-product-plp").style.display = "none";
    }
    else{
      activePopup.querySelector(".add-product-plp").style.display = "inline-block";
    }
  };
  // Handle availability logic for dependent option
  const handleAvailability = (activePopup, firstSwatch) => {
    const fieldsets = activePopup.querySelectorAll(".plp-options-wrapper fieldset");
    if (fieldsets.length < 2) return;

    const firstOptionName = fieldsets[0].id;
    const secondOptionName = fieldsets[1].id;

    if (firstSwatch.closest("fieldset").id !== firstOptionName) return;

    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return;

    const targetSelector = `#${escapeSelector(secondOptionName)} .swatch, #${escapeSelector(secondOptionName)} .button-swatch`;
    const targetSwatches = activePopup.querySelectorAll(targetSelector);

    let firstAvailable = null;
    const firstValue = firstSwatch.getAttribute("data-value") || firstSwatch.getAttribute("data-color");

    targetSwatches.forEach(ts => {
      const targetValue = ts.getAttribute("data-value") || ts.getAttribute("data-color");

      const match = Array.from(hiddenSelect.options).find(opt => {
        return (opt.getAttribute("data-option1") === firstValue && opt.getAttribute("data-option2") === targetValue);
      });

      const isAvailable = !!match;
      const isSoldout = match?.disabled || false;

      ts.classList.toggle("unavailable", !isAvailable);
      ts.classList.toggle("sold-out", !!isSoldout);

      if (isAvailable && !isSoldout && !firstAvailable) firstAvailable = ts;
    });

    const selectedTarget = activePopup.querySelector(`#${escapeSelector(secondOptionName)} .selected`);
    if (!selectedTarget || selectedTarget.classList.contains("unavailable") || selectedTarget.classList.contains("sold-out")) {
      if (firstAvailable) firstAvailable.click();
    }
    // Update price after availability changes
    setTimeout(() => {
      updatePrice(activePopup);
    }, 100);
  };

  // Handle visual selection
  const markSelected = (swatch) => {
    const optionGroup = swatch.closest("fieldset");
    if (!optionGroup) return;
    optionGroup.querySelectorAll("label").forEach(l => l.classList.remove("selected"));
    swatch.classList.add("selected");
  };

  // Get variant ID based on selected options
  const getSelectedVariantId = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    const matchedVariant = Array.from(hiddenSelect.options).find(opt => {
      const optValues = [
        opt.getAttribute("data-option1"),
        opt.getAttribute("data-option2"),
        opt.getAttribute("data-option3")
      ].filter(Boolean);

      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });

    return matchedVariant?.value || null;
  };
  const getSelectedVariantSellingPlanId = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    const matchedVariant = Array.from(hiddenSelect.options).find(opt => {
      const optValues = [
        opt.getAttribute("data-option1"),
        opt.getAttribute("data-option2"),
        opt.getAttribute("data-option3")
      ].filter(Boolean);

      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });

    return matchedVariant?.getAttribute('data-selling') || null;
  };
  // Add variant to cart
  const addToCart = (variantId,sellingId) => {
    if (!variantId) return;
    const payload = {
      id: variantId,
      quantity: 1
    };
    if (sellingId && sellingId != "" && sellingId != null) {
      payload.selling_plan = sellingId;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(() => document.querySelector('#cart-icon-bubble')?.click())
    .catch(err => console.error(err));
  };

  // Event delegation
  document.addEventListener("click", (e) => {
    const popupBtn = e.target.closest(".trigger-variant-popup");
    if (popupBtn) return handlePopupToggle(popupBtn);

    const swatch = e.target.closest(".button-swatch, .swatch");
    if (swatch) {
      const activePopup = document.querySelector(".plp-variant-inner.active-plp-variant");
      if (!activePopup) return;

      updateLabel(swatch);
      handleAvailability(activePopup, swatch);
      markSelected(swatch);
      return;
    }

    const addBtn = e.target.closest(".add-product-plp");
    if (addBtn) {
      const activePopup = addBtn.closest(".plp-variant-inner");
      if (!activePopup) return;
      const variantId = getSelectedVariantId(activePopup);
      const sellingId = getSelectedVariantSellingPlanId(activePopup);
      addToCart(variantId,sellingId);
      return;
    }

    if (!e.target.closest(".plp-variant-options") && !e.target.closest(".trigger-variant-popup")) {
      closeAllPopups();
    }
  });
  setTimeout(function(){
    renderSwatchDescriptions();
  },3000)
  
    function renderSwatchDescriptions() {
      document.querySelectorAll(".plp-swatch").forEach(swatch => {
        const sizeKey = swatch.getAttribute("data-value")?.toLowerCase();
        const sizeTextEl = swatch.querySelector(".size-text");
        if (sizeKey && window.sizeOptions && window.sizeOptions[sizeKey] && sizeTextEl) {
          sizeTextEl.textContent = window.sizeOptions[sizeKey].replace(/\/quote\//g, '"').replace(/\/apos\//g, "'");
        }
      });
    }
  }
// Enavi 3-1-R-HP-Featured Products ATC //

// Hide Review Stars if a product has less than 20 reviews.  //
(function () {
  document.querySelectorAll('.product__info-container [data-raters]').forEach(el => {
    const raters = parseInt(el.getAttribute('data-raters'), 10);
    if (isNaN(raters) || raters < 20) {
      const parent = el.parentElement;
      if (parent) parent.style.display = "none";
      if (!parent.nextElementSibling || !parent.nextElementSibling.classList.contains("product-grid-item__label")) {
        const span = document.createElement("span");
        span.className = "product-grid-item__label bg-[#B9CBDD] rounded-full text-sm font-medium text-[#191A1B] py-1 px-3 z-10";
        span.textContent = "NEW!";

        parent.insertAdjacentElement("afterend", span);
      }

    }
  });
})();
// Hide Review Stars if a product has less than 20 reviews.  //

// Implementation - 14-1-R-PDP-Chronic Pain Accordions //
(function () {
  const section = document.querySelector('.castleflexx-section');
  if (!section) return;
  const headers = section.querySelectorAll('.accordion-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const toggle = header.querySelector('.accordion-toggle');
      const isOpen = !content.classList.contains('hidden');
      section.querySelectorAll('.accordion-content').forEach(el => el.classList.add('hidden'));
      section.querySelectorAll('.accordion-toggle').forEach(el => el.textContent = '+');
      if (!isOpen) {
        content.classList.remove('hidden');
        toggle.textContent = '−';
      }
    });
  });
})();
// Implementation - 14-1-R-PDP-Chronic Pain Accordions //

// Implementation - 17-1-R-FIT-Product Image Carousel //
(function () {
  const mainContainer = document.querySelector('#main-swiper');
  const thumbContainer = document.querySelector('[js-thumb-slider="container"]');
  if (!mainContainer || !thumbContainer) return;
  const thumbSlider = new O(thumbContainer, {
    modules: [ne],
    slidesPerView: window.innerWidth >= 768 ? 7.5 : 5.5,
    loop: false,
    spaceBetween: 5,
    watchOverflow: true,
    watchSlidesProgress: true,
  });

  // Main slider
  const mainSlider = new O(mainContainer, {
    modules: [ne],
    slidesPerView: 1,
    loop: false,
    spaceBetween: 15,
  });

  // ---------- MANUAL SYNC ----------

  thumbSlider.slides.forEach((slide, index) => {
    slide.addEventListener("click", () => {
      mainSlider.slideTo(index);
    });
  });

  mainSlider.on("slideChange", () => {
    const index = mainSlider.activeIndex;

    thumbSlider.slides.forEach((slide, i) => {
      slide.classList.toggle("thumb-active", i === index);
    });

    thumbSlider.slideTo(index);
  });
})();
// Implementation - 17-1-R-FIT-Product Image Carousel //
})